import { useState } from "react";
import { ForgotPasswordForm } from "@/components/forgot-password";
import { ResetCodeVerification } from "@/components/reset-code-verification";
import { NewPasswordForm } from "@/components/new-password-form";
import { useLocation } from "wouter";

type Step = "email" | "code" | "password";

export default function ForgotPasswordPage() {
  const [, setLocation] = useLocation();
  const [step, setStep] = useState<Step>("email");
  const [email, setEmail] = useState("");
  const [resetToken, setResetToken] = useState("");

  const handleCodeSent = (userEmail: string) => {
    setEmail(userEmail);
    setStep("code");
  };

  const handleCodeVerified = (token: string) => {
    setResetToken(token);
    setStep("password");
  };

  const handleSuccess = () => {
    setLocation("/login");
  };

  const handleBackToEmail = () => {
    setStep("email");
    setEmail("");
    setResetToken("");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50 p-4">
      <div className="w-full max-w-md">
        {step === "email" && (
          <ForgotPasswordForm
            onBack={() => setLocation("/login")}
            onCodeSent={handleCodeSent}
          />
        )}

        {step === "code" && (
          <ResetCodeVerification
            email={email}
            onBack={handleBackToEmail}
            onCodeVerified={handleCodeVerified}
          />
        )}

        {step === "password" && (
          <NewPasswordForm
            resetToken={resetToken}
            onSuccess={handleSuccess}
          />
        )}
      </div>
    </div>
  );
}

